import { z } from 'zod';

/**
 * Who a subscription product is sold to.
 *
 * Gender-scoped pricing is a stated differentiator, and a store cannot express
 * "one product, two prices" — so a deployment that charges men and women
 * differently publishes two products and marks each with the gender it is for.
 * `all` is the ordinary case: one product, one price, both audiences.
 *
 * This is **data plumbing, never a policy branch** (U15). The catalog filters
 * by it; no code asks `if (gender === 'male')`.
 */
export const PRODUCT_AUDIENCES = ['all', 'male', 'female'] as const;

export const ProductAudienceSchema = z.enum(PRODUCT_AUDIENCES);

export type ProductAudience = (typeof PRODUCT_AUDIENCES)[number];

const AUDIENCE_SET: ReadonlySet<string> = new Set(PRODUCT_AUDIENCES);

export function isProductAudience(value: string): value is ProductAudience {
  return AUDIENCE_SET.has(value);
}
